import { FC, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useQuery } from 'react-query'
import { MaterialReactTable, MRT_ColumnDef, MRT_PaginationState, useMaterialReactTable } from 'material-react-table'
import { Button } from '@mui/material'
import { toast } from 'react-toastify'
import mrtLocalization from '../../constants/mrtLocalization'
import { EDrawerView } from '../../stores/DrawerCRUD.store'
import { useStore } from '../../stores'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import { formatToMoscowTZ } from '../../utils/date'
import { Prp2boxApiStands } from '../../prp2boxApi'
import { IRpStand } from '../../prp2boxApi/stands'

const columns: MRT_ColumnDef<IRpStand>[] = [
  {
    accessorKey: 'name',
    header: 'Имя',
  },
  {
    accessorKey: 'stream.name',
    header: 'Видеопоток',
  },
  {
    accessorKey: 'updatedAt',
    header: 'Последнее обновление',
    sortingFn: 'datetime',
    Cell: ({ cell }) => {
      return formatToMoscowTZ(cell.getValue<string>())
    },
  },
  // Добавьте другие столбцы при необходимости
]

const RpStandTable: FC = observer(() => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({ pageIndex: 0, pageSize: 10 })
  const { drawerCRUDStore } = useStore()

  const { data, isError, isFetching, isLoading } = useQuery(
    [EQueryKeysConstant.RP_STANDS, pagination.pageIndex, pagination.pageSize],
    () =>
      Prp2boxApiStands.getAll({
        limit: pagination.pageSize,
        offset: pagination.pageIndex * pagination.pageSize,
      }),
    {
      refetchOnWindowFocus: false,
      onError: (err) => toast.error(`${err}`),
      enabled: true,
      keepPreviousData: true,
    }
  )

  const table = useMaterialReactTable({
    ...mrtLocalization,
    enableGlobalFilter: false,
    data: data?.rows || [],
    columns,
    rowCount: data?.totalRows || 0,
    state: {
      pagination,
      isLoading,
      showAlertBanner: isError,
      showProgressBars: isFetching,
    },
    manualPagination: true,
    onPaginationChange: setPagination,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        event.preventDefault()
        event.stopPropagation()

        drawerCRUDStore.changeView(EDrawerView.RP_STAND_EDIT, String(row.original.id))
      },
      sx: {
        cursor: 'pointer',
      },
    }),
    renderTopToolbarCustomActions: () => {
      return (
        <Button
          variant="contained"
          onClick={() => {
            drawerCRUDStore.changeView(EDrawerView.RP_STAND_CREATE)
          }}>
          Создать новую стойку
        </Button>
      )
    },
  })

  return <MaterialReactTable table={table} />
})

export default RpStandTable
